import React from 'react';
import ChatMarkdownAnchor from '@/components/ChatMarkdownAnchor';
import ChatTableShell, {
  CHAT_TABLE_CLASS,
  CHAT_TABLE_HEAD_CLASS,
  CHAT_TABLE_TD_CLASS,
  CHAT_TABLE_TEXT_SELECT,
  CHAT_TABLE_TH_CLASS,
  CHAT_TABLE_TR_CLASS,
} from '@/components/ChatTableShell';

function ChatMarkdownTable({ children, ...props }) {
  return (
    <ChatTableShell>
      <table {...props} className={CHAT_TABLE_CLASS}>
        {children}
      </table>
    </ChatTableShell>
  );
}

export function createChatMarkdownComponents() {
  return {
    a: ChatMarkdownAnchor,
    p: ({ children, ...props }) => (
      <p {...props} className="mb-3 last:mb-0" style={CHAT_TABLE_TEXT_SELECT}>
        {children}
      </p>
    ),
    h1: ({ children, ...props }) => (
      <h1 {...props} className="text-lg font-bold mb-2 mt-4 first:mt-0">
        {children}
      </h1>
    ),
    h2: ({ children, ...props }) => (
      <h2 {...props} className="text-base font-bold mb-2 mt-4 first:mt-0">
        {children}
      </h2>
    ),
    h3: ({ children, ...props }) => (
      <h3 {...props} className="text-sm font-bold mb-2 mt-3 first:mt-0">
        {children}
      </h3>
    ),
    ul: ({ children, ...props }) => (
      <ul {...props} className="my-2 pl-5 space-y-1">
        {children}
      </ul>
    ),
    ol: ({ children, ...props }) => (
      <ol {...props} className="my-2 pl-5 space-y-1">
        {children}
      </ol>
    ),
    li: ({ children, ...props }) => (
      <li {...props} className="my-1">
        {children}
      </li>
    ),
    pre: ({ children, ...props }) => (
      <pre
        {...props}
        className="overflow-x-auto whitespace-pre-wrap break-words bg-gray-50 p-3 rounded my-2"
        style={CHAT_TABLE_TEXT_SELECT}
      >
        {children}
      </pre>
    ),
    code: ({ children, ...props }) => (
      <code
        {...props}
        className="whitespace-pre-wrap break-words bg-gray-100 px-1 rounded text-sm"
        style={CHAT_TABLE_TEXT_SELECT}
      >
        {children}
      </code>
    ),
    blockquote: ({ children, ...props }) => (
      <blockquote {...props} className="border-l-4 border-gray-300 pl-4 my-2 italic">
        {children}
      </blockquote>
    ),
    hr: ({ ...props }) => <hr {...props} className="my-4 border-gray-200" />,
    table: ChatMarkdownTable,
    thead: ({ children, ...props }) => (
      <thead {...props} className={CHAT_TABLE_HEAD_CLASS}>
        {children}
      </thead>
    ),
    th: ({ children, ...props }) => (
      <th {...props} className={CHAT_TABLE_TH_CLASS} style={CHAT_TABLE_TEXT_SELECT}>
        {children}
      </th>
    ),
    td: ({ children, ...props }) => (
      <td {...props} className={CHAT_TABLE_TD_CLASS} style={CHAT_TABLE_TEXT_SELECT}>
        {children}
      </td>
    ),
    tr: ({ children, ...props }) => (
      <tr {...props} className={CHAT_TABLE_TR_CLASS}>
        {children}
      </tr>
    ),
  };
}

export const CHAT_MARKDOWN_COMPONENTS = createChatMarkdownComponents();
